export const ONE_WORD_QUOTED_KEYWORD_PATTERN = /^"([^"\s]+)"$/;

export function extractQuotedOneWordKeyword(value: string | undefined): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  const quotedMatch = value.trim().match(ONE_WORD_QUOTED_KEYWORD_PATTERN);
  return quotedMatch ? quotedMatch[1] : null;
}
